<template>
  <div v-if="contractLog && contractLog.length">
    <v-card class="card" v-for="(item, index) in contractLog" :key="index">
      <v-card-text v-if="item.type == 'transfer'">
        <div>
          <b>{{ $t('contract.transfer_area_contract') }}</b>
          {{ $t('from') }} {{fullName(item.fromCustomer)}}
          <b>{{ $t('go_to') }}</b>
          {{fullName(item.toCustomer)}}
        </div>
        <div>
          {{ $t('when_date') }} {{dateFormat(item.createdAt)}}
          {{ $t('transfer_by') }} {{fromBy(item.createdBy)}}
        </div>
      </v-card-text>
      <v-card-text v-else>
        <div>
          <b>{{ $t('contract.renew_area_contract') }}</b>
          {{ $t('contract.from_contract') }}
          <b v-if="item.oldContract">
            <u>{{item.oldContract.contractId}}</u>
            {{ $t('customer.start_date', { date: dateFormat(item.oldContract.startDate.iso,'date') }) }}
            {{ $t('customer.end_date', { date: dateFormat(item.oldContract.endDate.iso,'date') }) }}
          </b>
        </div>
        <div v-if="item.newContract && nowContract && item.objectId == nowContract">
          {{ $t('contract.current_contract') }}
          <b>
            <u>{{item.newContract.contractId}}</u>
            {{ $t('customer.start_date', { date: dateFormat(item.newContract.startDate.iso,'date') }) }}
            {{ $t('customer.end_date', { date: dateFormat(item.newContract.endDate.iso,'date') }) }}
          </b>
        </div>
        <div>
          {{ $t('when_date') }} {{dateFormat(item.createdAt)}}
          {{ $t('contract.renew_contract_by') }} {{fromBy(item.createdBy)}}
        </div>
      </v-card-text>
    </v-card>
  </div>
  <div v-else>
    <v-card class="card">
      <v-card-text>{{ $t('contract.no_contract_history') }}</v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["contractLog"],
  computed: {
    nowContract() {
      let res, last;
      for (const contract of this.contractLog) {
        if (contract.type == "renew") {
          if (!last) {
            last = this.$moment(contract.createdAt);
            res = contract.objectId;
          }
          if (last.isBefore(this.$moment(contract.createdAt)))
            res = contract.objectId;
        }
      }
      return res;
    }
  },
  methods: {
    dateFormat(date, isFormat) {
      let res = "-";
      if (date) {
        let format = "DD/MM/YYYY, HH:mm";
        if (isFormat == "date") {
          format = "DD/MM/YYYY";
        }
        res = this.$moment(date).format(format);
      }
      return res;
    },
    fromBy(data) {
      let res = "-";
      if (data) {
        res = `${data.firstName} ${data.lastName}`;
      }
      return res;
    },
    fullName(data) {
      let res = "-";
      if (data && data.type == "company") {
        res = `${data.companyName}`;
      } else if (data && data.type == "personal") {
        res = `${data.title} ${data.firstName} ${data.lastName}`;
      }
      return res;
    }
  }
};
</script>

<style scoped>
.card {
  margin: 5px 0 15px;
}
</style>